const LANGUAGE_PREFIXES = {
    DE: '/de',
    'DE-CH': '/de-ch',
    'EN-CA': '/en-ca',
    FR: '/fr-ch',
    'FR-CA': '/fr-ca',
    'FR-FR': '/fr',
    NL: '/nl',
    IT: '/it',
    'IT-CH': '/it-ch',
    CZ: '/cz',
    FI: '/fi',
    PL: '/pl',
    SE: '/se',
    NO: '/nb',
    DK: '/dk',
    ES: '/es',
    PT: '/pt',
};

const LANGUAGE_FOLDERS = {
    EN: 'en',
    'EN-CA': 'en-ca',
    DE: 'de',
    'DE-CH': 'de-ch',
    FR: 'fr',
    'FR-CA': 'fr-ca',
    'FR-FR': 'fr',
    NL: 'nl',
    IT: 'it',
    'IT-CH': 'it-ch',
    CZ: 'cz',
    FI: 'fi',
    PL: 'pl',
    SE: 'se',
    NO: 'no',
    DK: 'dk',
    ES: 'es',
    PT: 'pt',
};

const LANGUAGE_LABELS = {
    EN: 'English',
    'EN-CA': 'English (Canada)',
    DE: 'Deutsch',
    'DE-CH': 'Deutsch (Schweiz)',
    FR: 'Français (Suisse)',
    'FR-CA': 'Français (Canada)',
    'FR-FR': 'Français (France)',
    NL: 'Nederlands',
    IT: 'Italiano',
    'IT-CH': 'Italiano (Svizzera)',
    CZ: 'Česky',
    FI: 'Suomi',
    PL: 'Polski',
    SE: 'Svenska',
    NO: 'Norsk',
    DK: 'Dansk',
    ES: 'Español',
    PT: 'Português',
};

export function normalizeLanguage(language) {
    return language || 'EN';
}

export function isDanaResourcesAvailable(language) {
    return normalizeLanguage(language) === 'EN';
}

function normalizeResourceCategory(value) {
    return String(value || '').trim().toLowerCase();
}

export function isDanaOnlyResource(item) {
    if (!item) {
        return false;
    }

    const categories = [];
    if (item.category != null) {
        categories.push(item.category);
    }
    if (Array.isArray(item.categories)) {
        categories.push(...item.categories);
    }

    const normalized = categories.map(normalizeResourceCategory);
    const hasDana = normalized.includes('dana');
    const hasSharedCategory = normalized.some((category) => (
        category === 'ypso' || category === 'ypsopump' || category === 'all'
    ));

    return hasDana && !hasSharedCategory;
}

export function getLanguagePrefix(language) {
    return LANGUAGE_PREFIXES[normalizeLanguage(language)] || '';
}

export function getLocaleFolder(language, overrides = {}) {
    const normalizedLanguage = normalizeLanguage(language);
    return overrides[normalizedLanguage] || LANGUAGE_FOLDERS[normalizedLanguage] || LANGUAGE_FOLDERS.EN;
}

export function isIOSLanguage(language) {
    const normalizedLanguage = normalizeLanguage(language);
    return !['EN-CA', 'FR-CA'].includes(normalizedLanguage);
}

export function getLanguageLabel(language) {
    return LANGUAGE_LABELS[normalizeLanguage(language)] || LANGUAGE_LABELS.EN;
}

export function getLanguageFromPath(pathname = '') {
    const path = (pathname || '').toLowerCase();
    if (path.startsWith('/de-ch')) return 'DE-CH';
    if (path.startsWith('/de')) return 'DE';
    if (path.startsWith('/en-ca')) return 'EN-CA';
    if (path.startsWith('/fr-ch')) return 'FR';
    if (path.startsWith('/fr-ca')) return 'FR-CA';
    if (path.startsWith('/fr')) return 'FR-FR';
    if (path.startsWith('/nl')) return 'NL';
    if (path.startsWith('/it-ch')) return 'IT-CH';
    if (path.startsWith('/it')) return 'IT';
    if (path.startsWith('/cz')) return 'CZ';
    if (path.startsWith('/fi')) return 'FI';
    if (path.startsWith('/pl')) return 'PL';
    if (path.startsWith('/se')) return 'SE';
    if (path.startsWith('/nb') && !path.startsWith('/notifications')) return 'NO';
    if (path.startsWith('/dk')) return 'DK';
    if (path.startsWith('/es')) return 'ES';
    if (path.startsWith('/pt')) return 'PT';
    return 'EN';
}
